import * as dc from "@/components/layout/list/defaultType";
import { RefObject } from "react";
import { DataListParams, DataListProp, DataParams, LayoutProps } from "../../layoutType";
import { FormInstance } from "antd";
import { defaultFloatFomatter, delColsFieldId, getNumber } from "../../input/inputFunction";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { fetchCommand } from "@/util/fetchutil";
import { getApiHostname } from "@/util/paramutil";
import { DataCols, DataColumnRecord } from "../../input/inputType";
import { brewingChangeCalc, brewingCount, getBrewingStep } from "../../inputCols/brewingCols";
import { koLocale } from "@/i18n/routing";
export const CafeResult = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;

  const utcOffset = dayjs().utcOffset() * 60000;
  const cafeSettingCount = 10;
  const cafeSettingFormName = "form.ant-form#CafeSettingData_Form";
  const cafeSettingDataName = "CafeSettingData";
  const cafeSettingResultName = "CafeSettingData_Result";

  const cafeTimerClear = () => {
    const memo = formMemo?.current;
    if (memo) {
      cafeTimers.forEach((term) => {
        if (memo[term] && memo[term].now) {
          delete memo[term].now;
        }
      });
    }
  };
  const cafeTimers = [
    "setting_step1_term",
    "setting_step2_term",
    "setting_step3_term",
    "setting_step4_term",
    "setting_step5_term",
    "setting_step6_term",
    "setting_step7_term",
    "setting_step8_term",
    "setting_step9_term",
    "setting_step_end_term",
    "setting_result_term",
  ];
  const cafeSettingInit = (data: any) => {
    if (form?.current) {
      const formObj = document.querySelector(cafeSettingFormName) as HTMLFormElement;
      if (formObj) {
        if (form.current.getFieldValue("setting_detail_use")) {
          formObj.classList.add("setting_detail_use");
        } else {
          formObj.classList.remove("setting_detail_use");
        }
        if (form.current.getFieldValue("setting_result_type") === "espresso") {
          formObj.classList.add("setting_espresso_use");
        } else {
          formObj.classList.remove("setting_espresso_use");
        }

        if (form.current.getFieldValue("step_detail")) {
          formObj.classList.remove("hidden_step_detail");
        } else {
          formObj.classList.add("hidden_step_detail");
        }
        if (form.current.getFieldValue("setting_rate_detail")) {
          formObj.classList.add("rate_detail_use");
        } else {
          formObj.classList.remove("rate_detail_use");
        }
        if (params?.setTimer) {
          params.setTimer({ timer: "setting_start_time", start: undefined });
        }
        cafeChangeCalc(null);
        return true;
      }
      Debug("cafeSettingInit formObj", formObj);
    }
    Debug("cafeSettingInit form?.current", form?.current);
    return false;
  };
  const cafeChangeCalc = (e: any) => {
    if (form?.current) {
      const start_mass_value = form.current.getFieldValue("setting_start_mass");
      const start_mass = getNumber(start_mass_value, 0);
      const result_mass = getNumber(form.current.getFieldValue("setting_result_mass"), 0);
      let total_mass = 0;
      const detail = form.current.getFieldValue("step_detail");
      if (detail) {
        for (let i = 1; i <= cafeSettingCount; i++) {
          const istr = cafeSettingCount == i ? "_end" : i + "";
          const step_mass_value = form.current.getFieldValue("setting_step" + istr + "_mass");
          if (step_mass_value === undefined || step_mass_value === null) {
            form.current.setFieldValue("setting_step" + istr + "_calc", null);
          } else {
            const step_mass = getNumber(step_mass_value, 0);
            total_mass += step_mass;
            if (step_mass !== 0 && total_mass !== 0) {
              form.current.setFieldValue("setting_step" + istr + "_calc", start_mass + total_mass);
            } else {
              form.current.setFieldValue("setting_step" + istr + "_calc", null);
            }
          }
        }
        if (result_mass !== 0 || total_mass !== 0) {
          form.current.setFieldValue("setting_result_calc", Math.floor((result_mass - total_mass) * 10) / 10);
        }
        if (result_mass !== 0) {
          form.current.setFieldValue("setting_result_total", start_mass + result_mass);
        } else {
          form.current.setFieldValue("setting_result_total", null);
        }
      } else {
        total_mass += getNumber(form.current.getFieldValue("setting_result_mass"), 0);
        if (result_mass !== 0) {
          form.current.setFieldValue("setting_result_calc", result_mass);
        } else {
          form.current.setFieldValue("setting_result_calc", null);
        }
      }
      if (result_mass !== 0) {
        form.current.setFieldValue("setting_result_total", start_mass + result_mass);
      } else {
        form.current.setFieldValue("setting_result_total", null);
      }
    }
  };
  const cafeSettingCommon: DataCols = {
    //setting_grinder: { fieldId: {} },
    setting_seq: dc.hidden,
    setting_detail: {
      label: "setting_detail_use",
      valueClassName: "min-h-9",
      fieldId: {
        setting_detail_use: {
          ...dc.useDefault,
          defaultValue: false,
          inputClassName: "my-auto mr-[4.25rem]",
          read: { itemClassName: "hidden" },
          onChange: (e: any) => {
            const formObj = document.querySelector(cafeSettingFormName) as HTMLFormElement;
            if (e.value) {
              formObj.classList.add("setting_detail_use");
            } else {
              formObj.classList.remove("setting_detail_use");
            }
          },
        },
        setting_rdt: {
          ...dc.count,
          inputClassName: dc.inputNumberClassName + " " + dc.settingDetail,
          placeholder: "rdt",
          tooltip: "rdt_count",
        },
        water_select: {
          ...dc.select,
          inputClassName: dc.inputSelectWidth + " " + dc.settingDetail,
          placeholder: "setting_water",
          tooltip: true,
          codeGroup: "WTR",
          // selectProp: { className: "setting_detail" },
          selectPropOption: { reloadButtonClassName: dc.settingDetail },
          // valueList: [
          //   { value: 1, label: "정수" },
          //   { value: 2, label: "생수" },
          //   { value: 3, label: "수돗물" },
          //   { value: 4, label: "기타" },
          // ],
        },
      },
    },
    setting_detail_1: {
      label: "setting_water",
      labelClassName: dc.mobileHidden,
      itemClassName: dc.settingDetail,
      fieldId: {
        water_hard: { ...dc.waterHard },
        water_alk: { ...dc.waterAlk },
        water_tds: { ...dc.waterTds },
      },
    },
    setting_detail_2: {
      label: "grinder",
      labelClassName: dc.mobileHidden,
      itemClassName: dc.settingDetail,
      fieldId: {
        grinder_zeropoint: {
          ...dc.number,
          inputClassName: dc.inputNumberClassName + " " + dc.settingDetail,
          placeholder: "grinder_zeropoint",
          tooltip: "grinder_zeropoint",
          tooltipPlacement: "top",
        },
        grinder_temp: {
          ...dc.temp,
          inputClassName: dc.temp.inputClassName + " " + dc.settingDetail,
          placeholder: "grinder",
          tooltip: "grinder_temp",
          tooltipPlacement: "top",
        },
        grinder_rpm: {
          ...dc.number,
          inputClassName: dc.inputNumberClassName + " " + dc.settingDetail,
          unit: "RPM",
          placeholder: "grinder",
          tooltip: "grinder_rpm",
          tooltipPlacement: "top",
        },
      },
    },
    setting_detail_3: {
      label: "espresso_part",
      labelClassName: dc.mobileHidden,
      itemClassName: "setting_detail setting_espresso",
      fieldId: {
        setting_shower: { ...dc.select, inputClassName: dc.inputSelectWidth, placeholder: "shower" },
        setting_basket: { ...dc.select, inputClassName: dc.inputSelectWidth, placeholder: "basket" },
        setting_temper: { ...dc.select, inputClassName: dc.inputSelectWidth, placeholder: "temper" },
      },
    },
    setting_detail_4: {
      label: "dosing",
      labelClassName: dc.mobileHidden,
      itemClassName: "setting_detail setting_espresso",
      fieldId: {
        setting_wdt: { ...dc.count, placeholder: "wdt", tooltip: "wdt_tooltip" },
        setting_dist: { ...dc.mm, placeholder: "distributor" },
        setting_temping_bar: { ...dc.bar, placeholder: "temping_bar" },
        //setting_temping_count: { ...dc.count, placeholder: "temping_count" },
      },
    },
    setting_grinder_setting: {
      labelClassName: dc.strongLabelClassName,
      fieldId: {
        setting_bean_mass: { ...dc.mass, placeholder: "bean_mass" },
        setting_grinder_size: {
          ...dc.number1f,
          placeholder: "grinder_size",
          formatter: defaultFloatFomatter,
          inputClassName: dc.inputNumberClassName,
        },
        setting_grinder_time: {
          ...dc.number2f,
          placeholder: "grinder_time",
          unit: "s",
          formatter: defaultFloatFomatter,
          inputClassName: dc.inputNumberClassName,
        },
      },
    },
    //setting_bean: { labelClassName: dc.strongLabelClassName, fieldId: {} },
    setting_info: {
      labelClassName: dc.strongLabelClassName,
      fieldId: {
        setting_result_mass: { ...dc.mass, placeholder: "result_mass", noItem: false, onChange: cafeChangeCalc },
        setting_temp: { ...dc.temp, placeholder: "setting_temp" },
        setting_bar: dc.brewingBar,
      },
    },
    setting_start: {
      labelClassName: dc.strongLabelClassName,
      fieldId: {
        setting_result_time: {
          ...dc.datetime,
          inputClassName: dc.roastingTimeWidth,
          noItem: false,
          readInputDisabled: false,
          tooltip: true,
          tooltipPlacement: "leftTop",
          indexKey: "setting_result_time",
          onChange: (e: any) => {
            if (params?.setTimer) {
              if (e && e.value) {
                params.setTimer({ timer: "setting_start_time", start: e.value, form: { form: form?.current, timers: cafeTimers } });
                if (form?.current) {
                  const setdate = form.current.getFieldValue("setting_date");
                  if (!setdate && e.value !== undefined) {
                    form.current.setFieldValue("setting_date", e.value);
                  }
                }
              } else {
                params.setTimer({ timer: "setting_start_time", start: undefined });
                cafeTimerClear();
              }
            }
          },
        },
        setting_start_mass: {
          ...dc.mass,
          readInputDisabled: false,
          noItem: false,
          readOnly: false,
          placeholder: "start_weight",
          placeholderForce: true,
          onChange: cafeChangeCalc,
        },
        step_detail: {
          ...dc.use,
          inputClassName: dc.inputCalcWidth + " my-auto",
          read: { inputClassName: "hidden" },
          noItem: false,
          switchProp: { checkedChildren: t("detail_enable"), unCheckedChildren: t("detail_disable") },
          defaultValue: false,
          onChange: (e: any) => {
            const formObj = document.querySelector(cafeSettingFormName) as HTMLFormElement;
            if (e.value) {
              formObj.classList.remove("hidden_step_detail");
            } else {
              formObj.classList.add("hidden_step_detail");
            }
            cafeChangeCalc(e);
          },
        },
      },
    },
    setting_step_explain: {
      label: "blank",
      labelClassName: dc.mobileHidden,
      itemClassName: "step_detail",
      fieldId: {
        setting_step_explia_main: {
          flexClassName: "setting_main",
          fieldId: {
            setting_step_explain_term: {
              ...dc.timer,
              disabled: true,
              readOnly: true,
              variant: "borderless",
              unit: "",
              inputClassName: dc.roastingTimeWidth,
              timeProp: { ...dc.timer.timeProp, nowButton: true },
              placeholder: "setting_step_time",
              noItem: true,
            },
            setting_step_explain_calc: {
              ...dc.brewingMassCalc,
              placeholder: "calc_mass",
              disabled: true,
              readOnly: true,
              variant: "borderless",
              unit: "",
              noItem: true,
            },
            setting_step_explain_mass: {
              ...dc.brewingMass,
              disabled: true,
              readOnly: true,
              variant: "borderless",
              unit: "",
              noItem: true,
            },
          },
        },
        setting_step_explain_sub: {
          flexClassName: "setting_sub ml-2 setting_espresso setting_detail hidden lg:flex",
          fieldId: {
            setting_step_explain_bar: {
              ...dc.brewingBar,
              disabled: true,
              readOnly: true,
              variant: "borderless",
              unit: "",
              noItem: true,
            },
            setting_step_explain_flux: {
              ...dc.brewingFlux,
              disabled: true,
              readOnly: true,
              variant: "borderless",
              unit: "",
              noItem: true,
            },
          },
        },
      },
    },
    ...getBrewingStep(brewingCount, false, () => brewingChangeCalc(form?.current, props.dataFunction?.current)),
    setting_step_end: {
      itemClassName: "step_detail",
      labelClassName: dc.mobileHidden,
      read: { display: "notNull", displayCheckIds: ["setting_step_end_term", "setting_step+_end_mass"] },
      fieldId: {
        setting_step_end_term: {
          ...dc.timer,
          inputClassName: dc.roastingTimeWidth,
          indexKey: "setting_result_time",
          noItem: false,
          //read: { timeProp: { ...dc.timer.timeProp, nowButton: false } },
        },
        setting_step_end_calc: dc.brewingMassCalc,
        setting_step_end_mass: { ...dc.brewingMass, hiddenCheckValue: undefined, onChange: cafeChangeCalc },
      },
    },
    setting_step_end_split: {
      label: "blank",
      itemClassName: "!hidden",
    },
    setting_result: {
      labelClassName: dc.strongLabelClassName,
      fieldId: {
        setting_result_term: {
          ...dc.timer,
          inputClassName: dc.roastingTimeWidth,
          indexKey: "setting_result_time",
          noItem: false,
          //readInputDisabled: false,
          onChange: (e: any) => {
            if (params?.setTimer) {
              if (e && e.value) {
                params.setTimer({ timer: "setting_start_time", start: undefined });
                cafeTimerClear();
              }
            }
          },
        },
        setting_result_total: dc.brewingMassCalc,
        setting_result_calc: { ...dc.brewingMassCalc, inputClassName: dc.inputNumberClassName },
      },
    },
  };
  const cafeSettingType: DataColumnRecord = {
    setting_type: {
      fieldId: {
        setting_bean_type: {
          ...dc.select,
          inputClassName: dc.inputSelectWidth,
          valueList: [
            { value: 1, label: "1번원두" },
            { value: 2, label: "2번원두" },
            { value: 3, label: "에티오피아" },
            { value: 4, label: "케냐" },
            { value: 5, label: "파나마" },
            { value: 6, label: "콜롬비아" },
          ],
          defaultValue: 1,
        },
        setting_grinder_name: {
          ...dc.select,
          valueList: [
            { value: 1, label: "말코닉E80" },
            { value: 2, label: "안핌" },
            { value: 3, label: "EK43" },
          ],
          defaultValue: 1,
        },
        setting_machine: {
          ...dc.select,
          valueList: [
            { value: 1, label: "에스프레소머신" },
            { value: 2, label: "플레어58+" },
            { value: 3, label: "하리오V60" },
            { value: 4, label: "칼리타웨이브" },
            { value: 5, label: "케맥스" },
            { value: 6, label: "클레버" },
          ],
          defaultValue: 1,
        },
      },
    },
  };
  const cafeSettingInputCommon: DataColumnRecord = {
    setting_name_group: {
      fieldId: {
        setting_name_select: {
          ...dc.selectSearch,
          inputClassName: dc.inputSelectWidth,
          valueList: [
            { value: 1, label: "에스프레소-1번" },
            { value: 2, label: "에스프레소-1번 라떼" },
            { value: 3, label: "에스프레소-2번" },
            { value: 4, label: "에스프레소-2번 라뗴" },
            { value: 5, label: "에티오피아 - 핸드드립" },
            { value: 6, label: "에티오피아 ICE - 핸드드립" },
            { value: 7, label: "케냐" },
            { value: 8, label: "케냐 ICE - 핸드드립" },
            { value: 9, label: "파나마 - 핸드드립" },
            { value: 10, label: "파나마 ICE - 핸드드립" },
            { value: 11, label: "콜롬비아 - 핸드드립" },
            { value: 12, label: "콜롬비아 ICE - 핸드드립" },
          ],
          defaultValue: 1,
        },
        setting_result_type: {
          ...dc.select,
          codeGroup: "EXTR",

          // codeGroupLabel: "feat",
          // valueList: [
          //   { value: "espresso", label: "에스프레소" },
          //   { value: "handdrip", label: "핸드드립" },
          //   { value: "coldbrew", label: "콜드브루" },
          // ],
          defaultValue: "DRP",
          onChange: (e) => {
            const formObj = document.querySelector(cafeSettingFormName) as HTMLFormElement;
            if (e.value === "ESP") {
              formObj.classList.add("setting_espresso_use");
            } else {
              formObj.classList.remove("setting_espresso_use");
            }
          },
        },
      },
    },
    ...cafeSettingType,
  };
  const cefeSettingBeanDetail: DataCols = {
    setting_bean_detail: {
      fieldId: {
        setting_bean_seq: {
          ...dc.selectSearch,
          inputClassName: dc.inputSelectWidth,
          valueList: [
            { value: 11, label: "1번원두 - 240909_1" },
            { value: 12, label: "1번원두 - 240909_3" },
            { value: 13, label: "1번원두 - 240907_2" },
            { value: 14, label: "1번원두 - 240907_3" },
            { value: 15, label: "1번원두 - 240903_4" },
            { value: 21, label: "2번원두 - 240908_1" },
            { value: 22, label: "2번원두 - 240908_2" },
            { value: 23, label: "2번원두 - 240906_3" },
            { value: 24, label: "2번원두 - 240903_2" },
            { value: 31, label: "에티오피아 - 240903_6" },
            { value: 32, label: "에티오피아 - 240902_5" },
            { value: 41, label: "케냐 - 240904_7" },
            { value: 42, label: "케냐 - 240902_8" },
            { value: 51, label: "파나마 - 240905_9" },
            { value: 52, label: "파나마 - 240903_12" },
            { value: 61, label: "콜롬비아 - 240907_7" },
            { value: 62, label: "콜롬비아 - 240906_13" },
          ],
          defaultValue: 11,
        },
      },
    },
  };

  const cafeSettingInput: DataCols = {
    ...cafeSettingInputCommon,
    ...cefeSettingBeanDetail,
    ...cafeSettingCommon,
  };
  switch (params?.page.page ?? "") {
    case "CafeSettingToday":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/setting/country/detail/" },
        listFetch: { fetchUrl: "/api/setting/country/list" },
        //formClassName: "large-font",
        dataResultName: cafeSettingResultName,
        dataName: cafeSettingDataName,
        timer: dc.brewingTimer,
        dataInit: cafeSettingInit,
        dataCols: {
          ...delColsFieldId(cafeSettingInputCommon, [{ setting_name_group: ["setting_result_type"] }]),
          ...cefeSettingBeanDetail,
          ...cafeSettingCommon,
          setting_result_memo: dc.textArea,
        },
        listColLinkField: "country_id",
        listCols: ["setting_name", "setting_summary", "setting_rate"],
      };
    case "CafeSettingDefault":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/setting/country/detail/" },
        listFetch: { fetchUrl: "/api/setting/country/list" },
        dataResultName: cafeSettingResultName,
        dataName: cafeSettingDataName,
        timer: dc.brewingTimer,
        dataInit: cafeSettingInit,
        dataCols: {
          setting_name: dc.input,
          ...cafeSettingType,
          ...cafeSettingCommon,
          setting_result_memo: dc.textArea,
          rgst_info: dc.rgst,
          edit_info: dc.edit,
        },
        listColLinkField: "country_id",
        listCols: ["setting_name", "setting_summary", "setting_rate"],
      };
    case "CafeSettingHistory":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/setting/country/detail/" },
        listFetch: { fetchUrl: "/api/setting/country/list" },
        dataResultName: cafeSettingResultName,
        dataName: cafeSettingDataName,
        timer: dc.brewingTimer,
        dataInit: cafeSettingInit,
        dataCols: {
          setting_date: { ...dc.date },
          ...cafeSettingInput,
          //setting_rate: dc.rateInput,
          condition: {
            label: "blank",
            labelClassName: dc.mobileHidden,
            fieldId: {
              condition_air: { ...dc.airTemp, readOnly: true, disabled: true, variant: "borderless", unit: "" },
              condition_hum: { ...dc.hum, readOnly: true, disabled: true, variant: "borderless", unit: "" },
            },
          },
          outside: {
            edit: { label: dc.weatherButton(form) },
            fieldId: {
              outside_air: dc.airTemp,
              outside_hum: dc.hum,
            },
          },
          inside: {
            fieldId: {
              inside_air: dc.airTemp,
              inside_hum: dc.hum,
            },
          },
          setting_summary: dc.textArea,
          setting_result_memo: dc.textArea,
          setting_pick: dc.useDefault,
          rgst_info: dc.rgst,
          edit_info: dc.edit,
        },
        listColLinkField: "country_id",
        listCols: ["setting_name", "setting_summary", "setting_rate"],
        tempValue: dc.tempSettingData,
      };
    case "CafeSettingNote":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/setting/country/detail/" },
        listFetch: { fetchUrl: "/api/setting/country/list" },
        //formClassName: "large-font",
        dataResultName: cafeSettingResultName,
        dataName: cafeSettingDataName,
        dataInit: cafeSettingInit,
        dataCols: {
          setting_date: { ...dc.date },
          ...cafeSettingInput,
          setting_rate: {
            ...dc.rateInput,
            readInputDisabled: false,
            noItem: false,
            read: { variant: undefined },
            disabled: false,
            readOnly: false,
          },
          setting_rate_detail: {
            ...dc.use,
            readInputDisabled: false,
            noItem: false,
            defaultValue: false,
            onChange: (e: any) => {
              const formObj = document.querySelector(cafeSettingFormName) as HTMLFormElement;
              if (e.value) {
                formObj.classList.add("rate_detail_use");
              } else {
                formObj.classList.remove("rate_detail_use");
              }
            },
          },
          setting_radar: {
            ...dc.cupRadar,
            itemClassName: "rate_detail",
            inputType: "radarRate",
            readInput: false,
            readInputDisabled: false,
            noItem: false,
            read: { variant: undefined },
            disabled: false,
            readOnly: false,
            fieldId: "country_seq",
            indexKey: "country_id",
            indexLabelKey: params?.locale === koLocale ? "country_name" : "country_nick",
          },
          setting_rate_comment: dc.textArea,
        },
        listColLinkField: "country_id",
        listCols: ["setting_name", "setting_summary", "setting_rate"],
        tempValue: dc.tempSettingData,
      };
    default:
      return undefined;
  }
};
